<template>
    <div class="policy-history-fab">
        <button
            type="button"
            class="policy-history-fab__btn"
            aria-label="历史版本"
            @click="open = !open"
        >
            历史版本
        </button>

        <div
            v-show="open"
            class="policy-history-fab__mask"
            @click="open = false"
        ></div>

        <div
            v-show="open"
            class="policy-history-fab__panel"
            role="dialog"
            aria-modal="true"
        >
            <p
                v-if="panelTitle"
                class="policy-history-fab__title"
            >
                {{panelTitle}}
            </p>
            <slot></slot>
        </div>
    </div>
</template>

<script>

export default {
    name: 'PolicyHistoryFab',
    props: {
        panelTitle: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            open: false,
        };
    },
    methods: {
        close() {
            this.open = false;
        },
    },
};
</script>

<style scoped>
/*
 * --policy-fab-top / --policy-fab-z 供页面覆盖：
 * 页面若使用固定顶栏（如 BackTar），需下移按钮并抬高层级避免被遮挡。
 */
.policy-history-fab__btn {
    position: fixed;
    top: var(--policy-fab-top, 12px);
    right: 12px;
    z-index: var(--policy-fab-z, 50);
    padding: 7px 12px;
    font-size: 12px;
    font-weight: 600;
    color: #444;
    background: #e9ecef;
    border: 1px solid #d8d8d8;
    border-radius: 6px;
    box-shadow: 0 1px 3px #00000014;
    cursor: pointer;
}

.policy-history-fab__btn:active {
    background: #dee2e6;
}

.policy-history-fab__mask {
    position: fixed;
    inset: 0;
    z-index: calc(var(--policy-fab-z, 50) + 10);
    background: #00000059;
}

.policy-history-fab__panel {
    position: fixed;
    top: calc(var(--policy-fab-top, 12px) + 36px);
    right: 12px;
    z-index: calc(var(--policy-fab-z, 50) + 20);
    width: min(320px, calc(100vw - 24px));
    max-height: min(420px, calc(100vh - 64px));
    overflow: auto;
    padding: 12px;
    background: #fff;
    border-radius: 10px;
    border: 1px solid #e8e8e8;
    box-shadow: 0 4px 20px #0000001f;
}

.policy-history-fab__title {
    margin: 0 0 10px;
    font-size: 14px;
    font-weight: 700;
    color: #1a1a1a;
}

@media (orientation: landscape) and (max-height: 520px) {
    .policy-history-fab__btn {
        top: var(--policy-fab-top, 8px);
        right: 8px;
        padding: 5px 10px;
        font-size: 11px;
    }

    .policy-history-fab__panel {
        top: calc(var(--policy-fab-top, 8px) + 34px);
        right: 8px;
        max-height: min(380px, calc(100vh - 52px));
    }
}
</style>
